import React from 'react'
import { Grid } from '@mui/material'
import { Button, CardPropiedad } from '@toctoc/design-system'

import { selectPropertiesResult } from 'src/app/reducers/properties';
import { useAppSelector } from 'src/app/hooks';
import { BannerMedio } from '@/components/particles/bannerMedio/BannerMedio';
import { IBannermedio } from '@/components/templates/search/interfaces/IEstructuraPrincipal';
import { IPropertyCard } from '@/components/templates/search/interfaces';
import { addImgSuffix } from '@/utils/url';
import { eOriginId, ePropertyCondition } from '@/app/globalContext/globalContext.interfaces';

const cloudfrontUrl = process.env.NEXT_PUBLIC_CLOUDFRONT_IMG;
const BANNER_POSITION = 7;

export const ListadoPropiedades = ({ cardWide, medio, listaSeoUrl, sessionInfo, guestSignUpModalHandler, selectedPropertyDataHandler, generateLead, quoteAndContactEnabled }: IBannermedio) => {
	const { isLogin, isGuest, userData } = sessionInfo ?? {};
	const results = useAppSelector(selectPropertiesResult);
	const resultsWithMedia: IPropertyCard[] = results !== undefined && results !== null ? [...results] : [];
	// This is like cheating, but, you know
	if (resultsWithMedia.length > BANNER_POSITION && medio !== undefined && medio !== null)
		resultsWithMedia.splice(BANNER_POSITION, 0, { urlFicha: 'media'} as IPropertyCard)

	const hasUserData = isLogin || isGuest;
	const isListaSeoItau = listaSeoUrl?.indexOf('itau') !== -1;

	const leadHandler = (selectedProperty: IPropertyCard) => {
		selectedPropertyDataHandler(selectedProperty);

		if (hasUserData) {
			generateLead({
				propertyId: selectedProperty.idProperty,
				originId: isListaSeoItau ? eOriginId.listaSeoItau : (selectedProperty.idEstadoPropiedad === ePropertyCondition.new ? eOriginId.listaSeoQuote : eOriginId.listaSeoContact),
				email: userData.email,
				utmSource: listaSeoUrl
			});
			guestSignUpModalHandler(true);
		} else {
			guestSignUpModalHandler(true);
		}
	}
	
	return (
		<Grid container rowSpacing={{ xs: 3, md: 3 }} columnSpacing={{ md: 2 }}>
			{resultsWithMedia.length > 0 && resultsWithMedia.map((info, index) => {
				const isBeneficioCliente = info.beneficioCliente !== undefined && info.beneficioCliente !== null;
				const showMoreButton = <>
					{quoteAndContactEnabled && <Button
						fullWidth
						variant='contained'
						style={{
							backgroundColor: isListaSeoItau ? "#FF6200" : "#3200C1",
						}}
						onClick={() => leadHandler(info)}
					>{info.idEstadoPropiedad === ePropertyCondition.new ? 'Cotizar' : 'Contactar'}</Button>}
					<Button
						fullWidth
						variant='outlined'
						style={{
							color: isListaSeoItau ? "#343A40" : "#3200C1",
							borderColor: isListaSeoItau ? "#343A40" : "#3200C1",
						}}
						href={isBeneficioCliente && isListaSeoItau ? `${info.urlFichaItau}?utm_source=${listaSeoUrl}` : `${info.urlFicha}`}
						target='_blank'
					>Ver más</Button>
				</>
				const partesURL = info.urlFicha.split('/');
				const ultimoParametro = partesURL[partesURL.length - 1];
				const sizeCard = cardWide ? 12 : 4
				return <Grid item xs={12} md={sizeCard} key={info.urlFicha} sx={{ zIndex: '1' }}>
					{medio !== undefined && index === BANNER_POSITION ? <BannerMedio medio={medio} cardWide={cardWide} /> :
						<CardPropiedad
							key={index}
							titulo={info.titulo}
							comuna={info.comuna}
							imagenPrincipal={{ src: addImgSuffix(info.imagenPrincipal.src, 'm_wm_'), alt: info.imagenPrincipal.alt ?? info.titulo }}
							imagenInmobiliaria={{ src: info.imagenInmobiliaria.src, alt: info.imagenInmobiliaria.alt }}
							urlFicha={isBeneficioCliente ? `${info.urlFicha}?utm_source=${listaSeoUrl}` : `${info.urlFicha}`}
							esDestacada={info.esDestacada}
							esFavorita={info.esFavorita}
							esOferta={info.esOferta}
							badge={info.badge}
							tipoPropiedad={info.tipoPropiedad}
							tipoOperacion={info.tipoOperacion}
							precios={info.precios}
							superficie={info.superficie}
							dormitorios={info.dormitorios}
							bannos={info.bannos}
							oferta={info.oferta}
							horasPublicado={info.horasPublicado}
							cardWide={cardWide}
							cloudfrontUrl={cloudfrontUrl}
							data-apartado={info.tipoOperacion + ' ' + info.tipoPropiedad}
							data-elemento={ultimoParametro}
							customContainer={showMoreButton}
							beneficioCliente={info.beneficioCliente}
							disableUrlFicha
						/>
					}

				</Grid>
			})}
		</Grid>
	)
}